export default {
    name: 'lazy-load-grid',

    props: {
        items: Array,
        isLoading: Boolean,
        featuredItemsIds: {
            type: Array,
            default: () => []
        },
    },

    data: () => (
        {
            itemsInGrid: [],
            itemsBank: [],
        }
    ),

    watch: {
        items: {
            handler() {
                this.itemsBank = [...this.items];
                this.addGridRows();
            },
        },
    },

    methods: {
        addGridRows() {
            const previousCellCount = this.gridCellCount;
            let minRowsFilled = false;
            while ((this.unevenGrid || !minRowsFilled) && !this.noMoreItems) {
                this.addItemsToGrid();
                minRowsFilled = this.gridCellCount - previousCellCount >= 9;
            }
        },
        addItemsToGrid(numberOfItems = 1) {
            const gridCount = this.itemsInGrid.length;
            this.itemsInGrid = this.itemsInGrid.concat(this.itemsBank.slice(gridCount, gridCount + numberOfItems));
        },
    },

    computed: {
        noMoreItems() {
            return this.itemsInGrid.length === this.itemsBank.length;
        },
        gridCellCount() {
            let count = 0;
            this.itemsInGrid.forEach((item) => {
                count += this.featuredItemsIds.includes(item.id) ? 2 : 1;
            });
            return count;
        },
        lastTwoAreDouble() {
            let bothAreDouble = null;
            if (this.itemsInGrid.length > 0) {
                const firstId = this.itemsInGrid.slice(-2, -1)[0].id;
                const secondId = this.itemsInGrid.slice(-1)[0].id;
                bothAreDouble = this.featuredItemsIds.includes(firstId) && this.featuredItemsIds.includes(secondId);
            }
            return bothAreDouble;
        },
        unevenGrid() {
            const unevenGridCellCount = this.gridCellCount % 3 !== 0;
            return unevenGridCellCount || this.lastTwoAreDouble;
        },
    },

    template: `
        <div>
            <div class="articles pb-base">
                <slot :itemsInGrid="itemsInGrid" :featuredItemsIds="featuredItemsIds"></slot>
                <h2 v-show="itemsInGrid.length < 1 && !isLoading">No items found.</h2>
                <img v-show="isLoading" class="search__loader" src="/dist/images/loader.gif">
            </div>
            <button v-if="!noMoreItems" class="btn mt-base" v-on:click="$emit('load-more')">Load more</button>
        </div>
    `,
};
